export default "__VITE_ASSET__DgKyWQWU__"